export const BROWSER_STORAGE_PREFIX = 'jira-issue-create-restore-';
